<template>
	<div>
		<v-dialog :value="showPhotoUpload" :fullscreen="$vuetify.breakpoint.smAndDown ? true : false"     
	  		width="30%">
	  		<PhotoUploadContent/>
		</v-dialog>
	</div>
</template>

<script>
import Vuex from "vuex";
import { mapState, mapMutations, mapActions } from "vuex";
import PhotoUploadContent from "./PhotoUploadContent"

export default {
	name: "FileUpload",

	components: { PhotoUploadContent, },

	data() {
		return {}
	},



	computed: {
		...mapState({
			showTestDialog: state => state.ui.showTestDialog,
		}),

		showPhotoUpload: {
			get() {
				return this.$store.state.ui.showPhotoUpload;
			},
			set(value) {
				this.setShowPhotoUpload(value);
			}
		}
	},

	methods: {
		...mapMutations(["setShowPhotoUpload",				]),
	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/forms/PhotoUpload.vue